import { useRef, useLayoutEffect } from "react";
import { useDispatch } from "react-redux";
import { resetWorkState } from "../../store";
import { resetWorkRefs } from "../../store/workRefs";
import WorkDetail from "./WorkDetail";

export default function WorkDetailPage() {
  const dispatch = useDispatch();

  // Reset WorkState slices + shared refs on MOUNT so each visit to WorkDetail starts pristine.
  // Runs once per mount (ref-guarded), before WorkDetail renders.
  const didReset = useRef(false);
  if (!didReset.current) {
    didReset.current = true;
    dispatch(resetWorkState());
    resetWorkRefs();
  }

  // Reset again on UNMOUNT so gallery state does not persist in the shared store after you leave
  // the gallery. On the old code this happened for free: WorkDetail's state lived in a nested
  // WorkStateProvider that unmounted with this component. useLayoutEffect cleanup runs before the
  // next page paints, so the behavior matches the old branch exactly (no leaked/stale state).
  useLayoutEffect(() => () => {
    dispatch(resetWorkState());
    resetWorkRefs();
  }, [dispatch]);

  return <WorkDetail />;
}
